"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const moment = require("moment");
const immutable_1 = require("immutable");
const LogManager_1 = require("../Log/LogManager");
const TypeScriptUtils_1 = require("../Common/TypeScriptUtils");
const CommonBaseError_1 = require("../Common/CommonBaseError");
const Entity_1 = require("../Common/Entity");
const RtcCommand_1 = require("../Engine/Command/RtcCommand");
const IEventHub_1 = require("../Engine/Event/IEventHub");
//import { NullEventHub } from '../Engine/Event/Port/NullEventHub';
const SessionDefinition_1 = require("./SessionDefinition");
const SessionCommand_1 = require("./SessionCommand");
const SessionEvent_1 = require("./SessionEvent");
const SessionTicket_1 = require("./Protocol/SessionTicket");
const SessionUtils_1 = require("./Protocol/SessionUtils");
const Attendee_1 = require("./Protocol/Attendee");
const SessionDto_1 = require("./Protocol/SessionDto");
class Session extends Entity_1.Entity {
    constructor(isService, sessionRepo, langyan, cmdHub, evtHub, s) {
        super(isService, Session.logger, SessionDefinition_1.SessionCommandCategory, cmdHub, SessionDefinition_1.SessionEventCategory, evtHub);
        this._id = "";
        this._version = Session.CurrentVersion;
        this._type = SessionDefinition_1.SessionType.Unknown;
        this._creator = Attendee_1.Creator.Nobody;
        this._attendees = new Set();
        // 參加過的Attendee與持續時間
        this._attendedAttendees = new Map();
        this._needRecord = false;
        this._createdFrom = new Date(0);
        this._endedTime = new Date(0);
        this._status = SessionDefinition_1.Status.Unknown;
        this._relatedRtcCommand = RtcCommand_1.RtcCommand.InvalidRtcCommand;
        this._sessionRepo = sessionRepo;
        this._langyan = langyan;
        if (s) {
            this.id = s.id || Session.GenerateId();
            this._type = s.Type || this._type;
            this._creator = new Attendee_1.Creator(s.Creator) || this._creator;
            const attendees = s.Attendees || this._attendees;
            this._attendees = attendees !== this._attendees ? new Set(attendees) : this._attendees;
            const attendAttendees = s.AttendedAttendees || this._attendedAttendees;
            this._attendedAttendees = attendAttendees !== this._attendedAttendees ? new Map(attendAttendees) : this._attendedAttendees;
            this._needRecord = s.NeedRecord || this._needRecord;
            this._createdFrom = new Date();
            this._status = s.Status || SessionDefinition_1.Status.Created;
        }
        this.registerAsyncCommandHandler(SessionCommand_1.SessionCommand.StartNewSession, async (rtcCmd) => this.OnStartNewSessionCommand(rtcCmd));
        this.registerAsyncEventHandler(SessionEvent_1.SessionEvent.SessionFailed, async (evt) => this.OnSessionFailedEvent(evt));
        this.registerAsyncEventHandler(SessionEvent_1.SessionEvent.SessionTerminated, async (evt) => this.OnStopSessionEvent(evt));
    }
    set id(value) { this._id = value; }
    get id() { return this._id; }
    //public set version(value: number) { this._version = value; }
    get Version() { return this._version; }
    get Type() { return this._type; }
    set Creator(value) { this._creator = value; }
    get Creator() { return this._creator; }
    get Attendees() { return new Set(this._attendees); }
    get AttendedAttendees() { return new Map(this._attendedAttendees); }
    get NeedRecord() { return this._needRecord; }
    get CreatedFrom() { return this._createdFrom; }
    //private set EndedTime(value: number) { this._endedTime = value; }
    get EndedTime() { return this._endedTime; }
    //public set Status(value: Status) { this._status = value; }
    get Status() { return this._status; }
    get Duration() {
        if (this.EndedTime.getTime() === 0 || this.CreatedFrom.getTime() === 0) {
            return moment.duration(0);
        }
        return moment.duration(this.EndedTime.getTime() - this.CreatedFrom.getTime());
    }
    Save() {
        this._sessionRepo.Save(this);
    }
    async StartAsync(starter, videoContainer = null) {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn(`Session is Ended.`);
            return;
        }
        if (!starter.isSame(this.Creator))
            throw new SessionError(`attendee=${starter} is not creator=${this.Creator}, cann't start this session`);
        const st = this.ToSessionTicket();
        const willBecomeStatus = SessionDefinition_1.Status.Starting;
        try {
            await this.BecomeStatusAsync(willBecomeStatus);
            switch (this.Type) {
                case SessionDefinition_1.SessionType.Video:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    if (!videoContainer)
                        throw new SessionError("No video container.");
                    await this._langyan.StartVideoAudioSessionAsync(starter, videoContainer, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, starter, ra, arg));
                    break;
                case SessionDefinition_1.SessionType.Audio:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    await this._langyan.StartAudioSessionAsync(starter, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, starter, ra, arg));
                    break;
                case SessionDefinition_1.SessionType.SharingScreen:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    if (!videoContainer)
                        throw new SessionError("No video container.");
                    await this._langyan.StartSharingScreenSessionAsync(starter, videoContainer, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, starter, ra, arg));
                    break;
                case SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    if (!videoContainer)
                        throw new SessionError("No video container.");
                    await this._langyan.StartVideoAudioSessionAsync(starter, videoContainer, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, starter, ra, arg));
                    break;
                default:
                    throw new SessionError(`Not supported SessionType=${this.Type}`);
            }
            for (const attendee of this._attendees) {
                //送Command給starter以外的所有人
                if (attendee.equals(starter))
                    continue;
                const startCmd = SessionCommand_1.SessionCommand.StartNewSessionCommand(TypeScriptUtils_1.NewTuple3(starter, attendee, st));
                await this.sendCommandAsync(startCmd);
                this._relatedRtcCommand = startCmd;
                await this.publishEventAsync(SessionEvent_1.SessionEvent.InvitationSentEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
            }
        }
        catch (error) {
            await this.BecomeStatusAsync(SessionDefinition_1.Status.Stopped);
            //送失敗的Event給starter以外的所有人
            const evtReceivers = immutable_1.Set(this.Attendees)
                .filter(a => a != null && !a.equals(starter))
                .map(a => a ? IEventHub_1.EventReceiver.from(a.id, a.name) : IEventHub_1.EventReceiver.Nobody)
                .concat(IEventHub_1.EventReceiver.CLIENT)
                .toArray();
            const message = `${starter.name} start ${this.Type} session failed, reason: ${error.message}`;
            await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionFailedEvent(TypeScriptUtils_1.NewTuple4(st, starter, willBecomeStatus, message)), evtReceivers);
            throw error;
        }
    }
    async StartDataSessionAsync(starter, localDataProvider, remoteDataReceiver, ctor) {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn(`Session is Ended.`);
            return;
        }
        if (!starter.isSame(this.Creator))
            throw new SessionError(`attendee=${starter} is not creator=${this.Creator}, cann't start this session`);
        if (this.Type !== SessionDefinition_1.SessionType.Data)
            throw new SessionError(`Only support SessionType=${SessionDefinition_1.SessionType.Data}`);
        const st = this.ToSessionTicket();
        const willBecomeStatus = SessionDefinition_1.Status.Starting;
        try {
            await this.BecomeStatusAsync(willBecomeStatus);
            await this._langyan.StartDataSessionAsync(starter, st, localDataProvider, remoteDataReceiver, ctor, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, starter, ra, arg));
            for (const attendee of this._attendees) {
                //送Command給starter以外的所有人
                if (attendee.equals(starter))
                    continue;
                const startCmd = SessionCommand_1.SessionCommand.StartNewSessionCommand(TypeScriptUtils_1.NewTuple3(starter, attendee, st));
                await this.sendCommandAsync(startCmd);
                this._relatedRtcCommand = startCmd;
            }
            await this.publishEventAsync(SessionEvent_1.SessionEvent.InvitationSentEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
        }
        catch (error) {
            await this.BecomeStatusAsync(SessionDefinition_1.Status.Stopped);
            //送失敗的Event給starter以外的所有人
            const evtReceivers = immutable_1.Set(this.Attendees)
                .filter(a => a != null && !a.equals(starter))
                .map(a => a ? IEventHub_1.EventReceiver.from(a.id, a.name) : IEventHub_1.EventReceiver.Nobody)
                .concat(IEventHub_1.EventReceiver.CLIENT)
                .toArray();
            const message = `${starter.name} start ${this.Type} session failed, reason: ${error.message}`;
            await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionFailedEvent(TypeScriptUtils_1.NewTuple4(st, starter, willBecomeStatus, message)), evtReceivers);
            throw error;
        }
    }
    async OnStartNewSessionCommand(rtcCmd) {
        const content = rtcCmd.contentTo();
        const cmdSender = new Attendee_1.Attendee(content.Item1);
        const selfCmdReceiver = new Attendee_1.Attendee(content.Item2);
        const incommingSt = new SessionTicket_1.SessionTicket(content.Item3);
        switch (rtcCmd.type) {
            case RtcCommand_1.CmdType.RequestExecute:
                if (this.Status === SessionDefinition_1.Status.Created) {
                    this._logger.debug("Prepare to join a new session");
                    this._relatedRtcCommand = rtcCmd;
                    await this.publishEventAsync(SessionEvent_1.SessionEvent.InvitationReceivedEvent(incommingSt), [IEventHub_1.EventReceiver.CLIENT]);
                }
                else {
                    this._logger.warn("Session已經在跑了，直接拒絕");
                    await this.InternalRejectAsync(Attendee_1.Attendee.from(selfCmdReceiver.id, selfCmdReceiver.name), rtcCmd);
                }
                break;
            case RtcCommand_1.CmdType.ResponseReject:
                {
                    if (!selfCmdReceiver.isSame(incommingSt.creator)) {
                        this._logger.warn(`${self} is not creator, no need to handle ${RtcCommand_1.CmdType.ResponseReject}`);
                        return;
                    }
                    this._logger.debug(`${rtcCmd.sender} rejected this session, stopping session.`);
                    await this.InternalStopAsync();
                    await this.publishEventAsync(SessionEvent_1.SessionEvent.InvitationRejectedEvent(incommingSt), [IEventHub_1.EventReceiver.CLIENT]);
                }
                break;
            case RtcCommand_1.CmdType.RequestCancel:
                {
                    if (selfCmdReceiver.isSame(incommingSt.creator)) {
                        this._logger.warn(`${self} is creator, no need to handle ${RtcCommand_1.CmdType.RequestCancel}`);
                        return;
                    }
                    this._logger.debug(`${rtcCmd.sender} cacneled this session, stopping session.`);
                    await this.InternalStopAsync();
                    await this.publishEventAsync(SessionEvent_1.SessionEvent.InvitationCanceledEvent(incommingSt), [IEventHub_1.EventReceiver.CLIENT]);
                }
                break;
            default:
                break;
        }
    }
    async StopAsync(attendee) {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn("Session is already Stopped.");
            return;
        }
        this._logger.debug("Stopping...");
        const lastStatus = this.Status;
        await this.InternalStopAsync();
        if (this.Creator.isSame(attendee) &&
            (lastStatus === SessionDefinition_1.Status.Created || lastStatus === SessionDefinition_1.Status.Starting)) {
            // TODO: 可以用所有Attendee來送CancelCommand，內含SessionId，就不需特別記錄_relatedRtcCommand
            if (this._relatedRtcCommand === RtcCommand_1.RtcCommand.InvalidRtcCommand)
                return;
            for (const a of this._attendees) {
                //送Command給starter以外的所有人
                if (a.equals(attendee))
                    continue;
                const cancelCmd = SessionCommand_1.SessionCommand.StartNewSessionCommandRequestCancel(this._relatedRtcCommand);
                await this.sendCommandAsync(cancelCmd);
            }
        }
        // 不需特別發SessionTerminatedEvent給參與者，因為所有參與者自己Link會斷開，各自會產生自己的SessionTerminatedEvent
        // 如果未連接的狀況，Langyan不會發OneLinkWithAttendeeDown，所以要自己發SessionTerminatedEvent
        // 已連接斷開的狀況，會收到Langyan發出OneLinkWithAttendeeDown，就會結束發出SessionTerminatedEvent
        if (lastStatus === SessionDefinition_1.Status.Starting) {
            const st = this.ToSessionTicket();
            // TODO: 如果Session還沒開始就被關閉，應該不能發SessionTerminatedEvent，因為還沒開始何來結束XD
            // 這部份行為的定義要再設計
            await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionTerminatedEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
        }
        this._logger.debug("Stopped.");
    }
    async ExitAsync(attendee) {
        await this.InternalStopAsync();
    }
    async InternalStopAsync() {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn("Session is Stopped.");
            return;
        }
        //InternalStopAsync不管成功或失敗狀態都是要變成Stopped
        await this.BecomeStatusAsync(SessionDefinition_1.Status.Stopped);
        //Stop動作實際上就是就是呼叫Langyan把Session停掉
        const st = this.ToSessionTicket();
        await this._langyan.StopSessionAsync(st);
    }
    async OnStopSessionEvent(e) {
    }
    async JoinAsync(joiner, videoContainer = null) {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn("Session is Ended.");
            return;
        }
        const st = this.ToSessionTicket();
        const willBecomeStatus = SessionDefinition_1.Status.Starting;
        try {
            await this.BecomeStatusAsync(willBecomeStatus);
            switch (this.Type) {
                case SessionDefinition_1.SessionType.Video:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    if (!videoContainer)
                        throw new SessionError("No video container.");
                    await this._langyan.StartVideoAudioSessionAsync(joiner, videoContainer, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, joiner, ra, arg));
                    break;
                case SessionDefinition_1.SessionType.Audio:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    await this._langyan.StartAudioSessionAsync(joiner, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, joiner, ra, arg));
                    break;
                case SessionDefinition_1.SessionType.SharingScreen:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    if (!videoContainer)
                        throw new SessionError("No video container.");
                    await this._langyan.StartSharingScreenSessionAsync(joiner, videoContainer, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, joiner, ra, arg));
                    break;
                case SessionDefinition_1.SessionType.CreatorVideoOnlyAllAudio:
                    if (this._langyan.HasGoingMediaSession())
                        throw new SessionError("There is another media session.");
                    if (!videoContainer)
                        throw new SessionError("No video container.");
                    await this._langyan.StartVideoAudioSessionAsync(joiner, videoContainer, st, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, joiner, ra, arg));
                    break;
                default:
                    throw new SessionError(`Not supported SessionType=${this.Type}`);
            }
        }
        catch (error) {
            await this.BecomeStatusAsync(SessionDefinition_1.Status.Stopped);
            //送失敗的Event給starter
            const evtReceivers = immutable_1.Set([IEventHub_1.EventReceiver.from(this.Creator.id, this.Creator.name), IEventHub_1.EventReceiver.CLIENT]).toArray();
            const message = `${joiner.name} join ${this.Type} session failed, reason: ${error.message}`;
            await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionFailedEvent(TypeScriptUtils_1.NewTuple4(st, joiner, willBecomeStatus, message)), evtReceivers);
            throw error;
        }
    }
    async JoinDataSessionAsync(joiner, localDataProvider, remoteDataReceiver, ctor) {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn("Session is Ended.");
            return;
        }
        if (this.Type !== SessionDefinition_1.SessionType.Data)
            throw new SessionError(`Only support SessionType=${SessionDefinition_1.SessionType.Data}`);
        const st = this.ToSessionTicket();
        const willBecomeStatus = SessionDefinition_1.Status.Starting;
        try {
            await this.BecomeStatusAsync(willBecomeStatus);
            await this._langyan.StartDataSessionAsync(joiner, st, localDataProvider, remoteDataReceiver, ctor, (st1, e, ra, arg) => this.OnConferenceEvent(st1, e, joiner, ra, arg));
        }
        catch (error) {
            await this.BecomeStatusAsync(SessionDefinition_1.Status.Stopped);
            //送失敗的Event給starter
            const evtReceivers = immutable_1.Set([IEventHub_1.EventReceiver.from(this.Creator.id, this.Creator.name), IEventHub_1.EventReceiver.CLIENT]).toArray();
            const message = `${joiner.name} join ${this.Type} session failed, reason: ${error.message}`;
            await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionFailedEvent(TypeScriptUtils_1.NewTuple4(st, joiner, willBecomeStatus, message)), evtReceivers);
            throw error;
        }
    }
    async RejectAsync(attendee) {
        if (this.Status === SessionDefinition_1.Status.Stopped) {
            this._logger.warn("Session is Ended.");
            return;
        }
        if (this._relatedRtcCommand === RtcCommand_1.RtcCommand.InvalidRtcCommand) {
            this._logger.warn("No related RtcCommand can be rejected.");
            return;
        }
        await this.InternalRejectAsync(attendee, this._relatedRtcCommand);
    }
    async InternalRejectAsync(attendee, rtcCmd) {
        const content = rtcCmd.contentTo();
        const cmdSender = new Attendee_1.Attendee(content.Item1);
        const selfCmdReceiver = new Attendee_1.Attendee(content.Item2);
        const incommingSt = new SessionTicket_1.SessionTicket(content.Item3);
        const rejectCmd = SessionCommand_1.SessionCommand.StartNewSessionCommandResponseReject(rtcCmd, TypeScriptUtils_1.NewTuple3(selfCmdReceiver, cmdSender, incommingSt));
        await this.sendCommandAsync(rejectCmd);
    }
    static GenerateId() {
        return SessionUtils_1.SessionUtils.GenerateId();
    }
    async OnConferenceEvent(st, e, localAttendee, remoteAttendee, parameter) {
        this._logger.debug(`Receive ConferenceEvent=${e}`);
        switch (e) {
            case SessionInternalEvent.OnLinkWithAttendeeInit:
                await this.publishEventAsync(SessionEvent_1.SessionEvent.LinkWithAttendeeWasInitedEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
                break;
            case SessionInternalEvent.OneLinkWithAttendeeUp:
                this.AddAttendee(remoteAttendee);
                this._logger.debug(`Attendee ${remoteAttendee.name} enters session ${JSON.stringify(this.Attendees)}`);
                //有一個Link建立起來就算開始
                await this.BecomeStatusAsync(SessionDefinition_1.Status.Started);
                await this.publishEventAsync(SessionEvent_1.SessionEvent.LinkWithAttendeeWasUpEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
                break;
            case SessionInternalEvent.OneLinkWithAttendeeDown:
                this.RemoveAttendee(remoteAttendee);
                this._logger.debug(`Attendee ${remoteAttendee.name} leaves session ${JSON.stringify(this.Attendees)}`);
                await this.publishEventAsync(SessionEvent_1.SessionEvent.LinkWithAttendeeWasDownEvent(new TypeScriptUtils_1.Tuple2({
                    Item1: st,
                    Item2: remoteAttendee
                })), [IEventHub_1.EventReceiver.CLIENT]);
                if (localAttendee.isSame(this.Creator)) {
                    //Session發起者如果只剩下自己，就結束
                    if (this.Attendees.size <= 1)
                        await this.InternalStopAsync();
                    await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionTerminatedEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
                }
                else {
                    //Session參與者直接結束
                    await this.InternalStopAsync();
                    await this.publishEventAsync(SessionEvent_1.SessionEvent.SessionTerminatedEvent(st), [IEventHub_1.EventReceiver.CLIENT]);
                }
                break;
            case SessionInternalEvent.OneLinkWithAttendeePacketLossPercentChanged:
                if (parameter != null) {
                    //封包丟失率有變化
                    const percentLoss = parameter;
                    await this.publishEventAsync(SessionEvent_1.SessionEvent.LinkWithAttendeePacketLossPercentChangedEvent(new TypeScriptUtils_1.Tuple3({
                        Item1: st,
                        Item2: remoteAttendee,
                        Item3: percentLoss
                    })), [IEventHub_1.EventReceiver.CLIENT]);
                }
                break;
        }
    }
    AddAttendee(a) {
        this._attendees.add(a);
        //參與者加入Session，記錄與Session開始相差的時間
        const currentTimestamp = Date.now();
        const durationWithSessionStart = moment.duration(currentTimestamp - this.CreatedFrom.getTime());
        const attendeeKey = this.FindAttendee(a);
        if (attendeeKey === Attendee_1.Attendee.Nobody) {
            this._attendedAttendees.set(a, durationWithSessionStart);
        }
        else {
            //如果Attendee存在，就表示重新加入，把之前的時間刷掉。
            this._attendedAttendees.set(attendeeKey, durationWithSessionStart);
        }
        this._logger.debug(`${a} joined to Session, after session created=${durationWithSessionStart}`);
    }
    RemoveAttendee(a) {
        this._attendees.forEach(curAttendee => {
            if (curAttendee.equals(a))
                this._attendees.delete(curAttendee);
        });
        // 參與者離開Session，計算參與者在Session的時間
        const currentTimestamp = Date.now();
        let durationWithSessionStart = moment.duration(currentTimestamp - this.CreatedFrom.getTime());
        const attendeeKey = this.FindAttendee(a);
        if (attendeeKey === Attendee_1.Attendee.Nobody) {
            //如果之前沒有記錄Duration，就直接減掉Session開始時間當作參與時間
            this._attendedAttendees.set(a, durationWithSessionStart);
        }
        else {
            //減去之前記錄的Duration，就可以得到Attendee在Session的參與時間。
            durationWithSessionStart = durationWithSessionStart.subtract(this._attendedAttendees.get(a));
            this._attendedAttendees.set(attendeeKey, durationWithSessionStart);
        }
        this._logger.debug(`${a} left from Session, duration of attendee session=${durationWithSessionStart}`);
    }
    FindAttendee(aAttendee) {
        for (const a of this._attendees) {
            if (a.equals(aAttendee))
                return a;
        }
        return Attendee_1.Attendee.Nobody;
    }
    DurationOfAttendeeSession(a) {
        const foundAttendee = this.FindAttendeeInAttendedAttendees(a);
        if (foundAttendee === Attendee_1.Attendee.Nobody) {
            this._logger.warn(`No duration for this attendee=${a}`);
            return moment.duration(0);
        }
        return this._attendedAttendees.get(foundAttendee) || moment.duration(0);
    }
    FindAttendeeInAttendedAttendees(a) {
        let foundAttendee = Attendee_1.Attendee.Nobody;
        this._attendedAttendees.forEach((value, key) => {
            if (a.equals(key)) {
                foundAttendee = key;
            }
        });
        return foundAttendee;
    }
    async BecomeStatusAsync(becomingStatus) {
        this._status = becomingStatus;
        switch (this.Status) {
            case SessionDefinition_1.Status.Started:
                break;
            case SessionDefinition_1.Status.Stopped:
                this._endedTime = new Date();
                break;
        }
        this.Save();
    }
    async OnSessionFailedEvent(evt) {
        await this.publishEventAsync(evt, [IEventHub_1.EventReceiver.CLIENT]);
    }
    ToSessionTicket() {
        return SessionTicket_1.SessionTicket.Builder()
            .Id(this.id)
            .Type(this.Type)
            .Creator(this.Creator)
            .NeedRecord(this.NeedRecord)
            .Build();
    }
    ToSessionDto() {
        const attendAttendees = new Map();
        this.AttendedAttendees.forEach((v, k) => {
            attendAttendees.set(k, v.asMilliseconds());
        });
        return new SessionDto_1.SessionDto({
            id: this.id,
            type: this.Type,
            creator: this.Creator,
            attendees: new Set(this.Attendees),
            attendedAttendees: attendAttendees,
            needRecord: this.NeedRecord,
            createdFrom: this.CreatedFrom.getTime(),
            endedTime: this.EndedTime.getTime(),
            status: this.Status,
        });
    }
}
Session.logger = LogManager_1.logManager.GetLogger("Session");
Session.CurrentVersion = SessionDefinition_1.SessionVersion;
Session.INVALID_SESSION = new Session(false, {}, {}, //new NullLangyan(),
{}, //new NullCommandHub(),
{} //new NullEventHub()
);
exports.Session = Session;
var SessionInternalEvent;
(function (SessionInternalEvent) {
    SessionInternalEvent["OnLinkWithAttendeeInit"] = "OnLinkWithAttendeeInit";
    SessionInternalEvent["OneLinkWithAttendeeUp"] = "OneLinkWithAttendeeUp";
    SessionInternalEvent["OneLinkWithAttendeeDown"] = "OneLinkWithAttendeeDown";
    SessionInternalEvent["OneLinkWithAttendeePacketLossPercentChanged"] = "OneLinkWithAttendeePacketLossPercentChanged";
})(SessionInternalEvent = exports.SessionInternalEvent || (exports.SessionInternalEvent = {}));
exports.SessionErrorName = "SessionError";
class SessionError extends CommonBaseError_1.CommonBaseError {
}
exports.SessionError = SessionError;
//# sourceMappingURL=Session.js.map